import { useEffect } from "react";
import Lenis from "lenis";
import { setLenis } from "@/lib/scroll";
import { WHATSAPP_URL } from "@/lib/api";
import { LeadModalProvider } from "@/components/LeadModal";
import { Navbar } from "@/components/Navbar";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import { Hero } from "@/sections/Hero";
import { Marquee } from "@/sections/Marquee";
import { HowItWorks } from "@/sections/HowItWorks";
import { ForAgencies } from "@/sections/ForAgencies";
import { Services } from "@/sections/Services";
import { Audiences } from "@/sections/Audiences";
import { Technology } from "@/sections/Technology";
import { Benefits } from "@/sections/Benefits";
import { Stats } from "@/sections/Stats";
import { ImpactBanner } from "@/sections/ImpactBanner";
import { Partners } from "@/sections/Partners";
import { Faq } from "@/sections/Faq";
import { FinalCTA } from "@/sections/FinalCTA";
import { Footer } from "@/sections/Footer";

export default function Landing() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    setLenis(lenis);
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      setLenis(null);
    };
  }, []);

  return (
    <LeadModalProvider>
      <div className="min-h-screen bg-background" data-testid="landing-page">
        <Navbar />
        <main>
          <Hero />
          <Marquee />
          <HowItWorks />
          <ForAgencies />
          <Services />
          <Audiences />
          <Technology />
          <Benefits />
          <Stats />
          <ImpactBanner />
          <Partners />
          <Faq />
          <FinalCTA />
        </main>
        <Footer />
        <WhatsAppFloat url={WHATSAPP_URL} />
      </div>
    </LeadModalProvider>
  );
}
